import A from "./A";
import LocationPicker from "./LocationPicker";
import TemplatePreview from "./TemplatePreview";
import ChannelConfig from "./ChannelConfig";
import ammendChannels from './ammendChannels';

import { TemplateChannelPickerContext } from './Contexts';
import MicroscopyTemplatePickers from "./MicroscopyTemplatePickers";
import getDefaultChannels from './getDefaultChannels';
import NewStructurePicker from "./NewStructurePicker";
import G from './Getters';
import MicroscopyTemplateThumbnail from './MicroscopyTemplateThumbnail';
import HardCodedMicroscopyTemplateMap from './HardCodedMicroscopyTemplateMap';

window.JS = JSON.stringify


export default function TemplateCreator({
  //defaultTemplate=__defaultTemplate,
  template,
  templateDispatch,
}){


  //const editingContext = useContext(TemplateEditingContext);


  /*
  useEffect(() => {
    console.log("sending up a changed template");
    if( template ){
      editingContext?.setTemplate && editingContext?.setTemplate({compact:template})
    }
  },[template])
  */


  let { channelGroupStructure, channelGroups, channels={}, regionLocation, scalebarLocation, textLocation } = template.compact;



  let localTemplates = HardCodedMicroscopyTemplateMap; 


  let key = Object.keys(localTemplates)[0];

  //let images = template.compact.channels;

  let ammended = ammendChannels(template.compact || localTemplates[key],template.compact);

  let expansion;
  try{ 
    expansion = G.getTemplateExpansion(null,ammended);
  }catch(e){
    debugger;
    expansion = false
  }
  if( expansion === false ){
    return (
      <div class="outline">
        <div>TEMPLATE ISSUE</div>

      </div>

    )
  }


  let config = (

    <div style={{
      borderLeft:'1px solid #ccc',
      paddingLeft:20,
    }} class="sg-col">

      <h4>Options</h4>

      {channelGroupStructure && <>


        {true && <div class="small-padding" style={{
          //background:'white',border:'1px solid #ccc', borderRadius:10
        }}>

          <MicroscopyTemplatePickers {...{template,templateDispatch}}/>

        </div>}
      </>}
    </div>
  )



  let locationPicker = true && <LocationPicker/>;

  console.log(key);




  return (

      <div>



        {false && locationPicker}
        
        

        <div class="sg-row flex-expand h-center rel" style={{
          minHeight:0,
          marginLeft:30,
          flexWrap:'wrap',
        }}>


          <TemplatePreview {...{
            key,template,expansion,templateDispatch
          }}/>



          <ChannelConfig {...{
            template,
            structure:channelGroupStructure,
            data:channels,
            templateDispatch,
          }}/>




          {false && config}

        </div>



        <div>
          {false && <button onClick={() => {
            console.log(JSON.stringify(template.compact,null,1))
            console.log(template.compact);
          }}>Log template.compact</button>}
        </div>




      </div>
  )


}







